import { Skeleton } from 'ui/skeleton';

export default function StackedBarChartSkeleton() {
  return (
    <div className="w-full rounded-sm bg-card px-5 py-6">
      {/* Chart area */}
      <div className="flex h-[500px] w-full justify-between">
        {/* Bar section */}
        <div className="flex flex-1 items-end justify-between gap-4 px-4">
          {Array.from({ length: 7 }).map((_, index) => (
            <div key={index} className="flex flex-col items-center justify-end gap-2 flex-1 h-full">
              {/* Fake stacked bars */}
              <div className="flex h-full items-end gap-0.5">
                <Skeleton
                  className="w-2 rounded-sm"
                  style={{
                    height: `${120 + (index % 3) * 50}px`,
                  }}
                />
                <Skeleton
                  className="w-2 rounded-sm"
                  style={{
                    height: `${180 + (index % 2) * 40}px`,
                  }}
                />
                <Skeleton
                  className="w-2 rounded-sm"
                  style={{
                    height: `${90 + index * 15}px`,
                  }}
                />
              </div>

              {/* weekday label */}
              <Skeleton className="h-3 w-5" />
            </div>
          ))}
        </div>

        {/* Legend */}
        <div className="ml-6 w-[150px] space-y-4 mt-56">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <div className="flex items-center gap-2">
                <Skeleton className="size-2 rounded-full" />
                <Skeleton className="h-3 w-20" />
              </div>

              <div className="flex items-center gap-2">
                <Skeleton className="h-1 flex-1 rounded-full" />
                <Skeleton className="h-3 w-8" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
